import React, { useState } from "react";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { Button, message, Modal } from "antd";
import { connect } from "react-redux";
import {
  getUserRoleId,
  getClientid,
  getRoleList,
  getUserRole,
  getMenuList,
  getUserList,
  getUserInfo,
} from "redux/selectors";
import { Row, Col } from "antd";
import styled from "@emotion/styled";
import CheckInCheckout from "molecules/CheckInCheckout";
import UserMonthlyReport from "molecules/UserMonthlyReport";
import UserCheckinReport from "molecules/UserCheckinReport";
import NonStaffDashboard from "molecules/NonStaffDashboard";
import UserLeaveReport from "molecules/UserLeaveReport";
import { EyeFilled } from "@ant-design/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const StyledRow = styled(Row)`
  padding-top: 5px;
`;

const MyDashboard = ({ userRoleId, userInfo }) => {
  const [visitorId, setVisitorId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showFingerprint, setShowFingerprint] = useState(false);
  const history = useHistory();

  const handleFingerprintCheckInModal = () => {
    setShowFingerprint(true);
  };

  const handleFingerprintCheckIn = async () => {
    setIsLoading(true);
    try {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      setVisitorId(result.visitorId);

      // OPTIONAL: Send to your backend for validation
      // await fetch('/api/validate-fingerprint', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({ fingerprint: result.visitorId })
      // });

      message.success("Fingerprint ID: " + result.visitorId);
      // setShow(false);
    } catch (err) {
      message.error("Failed to get fingerprint");
    }
    setIsLoading(false);
  };

  return (
    <div>
      <EyeFilled
        style={{ position: "absolute", top: -20, right: 10, fontSize: 20 }}
        className=""
        onClick={() => history.push("/myshift")}
      />
      {/* Finger Print Check In Button and Result */}
      <div style={{ marginBottom: 16 }}>
        {/* <Button type="primary" onClick={handleFingerprintCheckInModal} loading={isLoading}>
          Finger Print Check In
        </Button> */}

        {showFingerprint && (
          <Modal
            open={showFingerprint}
            onCancel={() => setShowFingerprint(false)}
          >
            <div
              style={{
                marginTop: 12,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src="https://img.icons8.com/ios-filled/100/fingerprint.png"
                alt="Fingerprint"
                style={{ cursor: "pointer", width: "80px" }}
                onClick={handleFingerprintCheckIn}
              />
              <p className="mt-3">Tap the fingerprint to authenticate</p>
            </div>
          </Modal>
        )}
      </div>
      <>
        <StyledRow gutter={16}>
          <Col md={24} sm={24} xs={24} xl={12}>
            <Col md={24} sm={24} xs={24} xl={24}>
              <CheckInCheckout />
            </Col>

            <Col md={24} sm={24} xs={24} xl={24}>
              <UserMonthlyReport />
            </Col>
          </Col>
          <Col style={{ marginBottom: "25px" }} md={24} sm={24} xs={24} xl={12}>
            <Col className="h-100" md={24} sm={24} xs={24} xl={24}>
              <UserCheckinReport />
            </Col>
          </Col>
          <Col md={24} sm={24} xs={24} xl={24}>
            <Col md={24} sm={24} xs={24} xl={24}>
              <UserLeaveReport />
            </Col>
          </Col>
        </StyledRow>
        {/* <StyledRow gutter={16}>
          <Col md={24} sm={24} xs={24} xl={12}>
            <Col md={24} sm={24} xs={24} xl={24}>
              <CheckInCheckout />
            </Col>

            <Col md={24} sm={24} xs={24} xl={24}>
              <UserMonthlyReport />
            </Col>
          </Col>
          <Col style={{ marginBottom: "25px" }} md={24} sm={24} xs={24} xl={12}>
            <Col className="h-100" md={24} sm={24} xs={24} xl={24}>
              <UserCheckinReport />
            </Col>
          </Col>
          <Col md={24} sm={24} xs={24} xl={24}>
            <Col md={24} sm={24} xs={24} xl={24}>
              <UserLeaveReport />
            </Col>
          </Col>
        </StyledRow> */}
      </>
      {userRoleId == 1 && <NonStaffDashboard />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  ClientId: getClientid(state),
  roleList: getRoleList(state),
  userRoleType: getUserRole(state),
  menuList: getMenuList(state),
  userList: getUserList(state),
  userInfo: getUserInfo(state),
});

export default connect(mapStateToProps, null)(MyDashboard);
